export default __webpack_public_path__ + "static/media/sl2-min.5b61769a.jpg";